// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum SecureCarCalltype {
  front_cc = 1,
  rear_cc = 2,
  front_hc_up = 3,
  front_hc_down = 4,
  rear_hc_up = 5,
  rear_hc_down = 6,
}
